import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { IngredientsServices } from '../ingredients/services';
import { ProductsServices } from '../products/services';
import { HttpParams, HttpClient } from '@angular/common/http';
import { StockServices } from '../stock/services';


//interface
interface Provider {
  UID: string;
  UID_RESTAURANT: string;
  name: string;
  nif: string;
  address: string;
  province: string;
  city: string;
  phone: string;
  country: string;
  email: string;
  contact_name: string;
  fixed_phone: string;
  web: string;
  cp: string;
  no_provider: boolean;
}

//interface
interface ProviderOrder {
  UID: string;
  UID_RESTAURANT: string;
  UID_USER: string;
  created_at: Date;
  delibery_note: boolean;
  list: any;
  notes: string;
  provider_email: string;
  provider_phone: string;
  provider_static: string;
  state: string;
  sended_by: string;
  uid_delibery_note: string;
  uid_provider: string;
}

//interface
interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  stock_max: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  preparation: string;
  created_at: any;
}


@Injectable()
export class ProvidersServices {
  public firestore: any;
  providerCol: AngularFirestoreCollection<Provider>;
  providers: Observable<Provider[]>;
  providerDoc: AngularFirestoreDocument<Provider>;
  provider: Observable<Provider[]>;
  providers_stock: Observable<Provider[]>;

  ingredientsCol: AngularFirestoreCollection<Ingredient>;
  ingredients_provider: Observable<Ingredient[]>;

  providerOrderCol: AngularFirestoreCollection<ProviderOrder>;
  providerOrderDoc: AngularFirestoreDocument<ProviderOrder>;
  providerOrders: Observable<ProviderOrder[]>;

  //deleteStat: boolean = false;

  //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
  public providers_array_tmp = Array();
  public providers_tmp = Array();
  public quick_create: boolean = false;
  public pagesProviders: any;
  public page_active: number = 1;
  public limit_pages: number = 50;
  public first_providers_name: any = [];
  public get_providers_done: boolean = false;
  public list_providers: any;
  public pagesIngredients: any;
  public ings_prods_error: any = [];
  public list_providers_array_tmp = Array();
  public total_orders_suppliers: number = 0;

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    private ingredientsServices: IngredientsServices,
    private productsServices: ProductsServices,
    public http: HttpClient,
    public stockServices: StockServices,) {
    this.firestore = firebase.firestore();
  }

  getListProviders(UID_RESTAURANT) {

    let limit = this.globals.checkLimitsByLicense('stock', 'providers');

    //miramos si la versión tiene un límite de proveedores
    if (limit == -1) {
      //si no, devolvemos todos los proveedores
      this.providerCol = this.afs.collection('providers', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('name', 'asc'));
      this.providers = this.providerCol.snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Provider;
          data.UID = a.payload.doc.id;
          return data;
        });
      });
    } else {
      //Si tiene límite, buscamos por query él sin proveedor y los otros x primeros proveedores

      this.providerCol = this.afs.collection('providers', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('no_provider', 'desc').orderBy('name', 'asc').limit(limit + 1));
      this.providers = this.providerCol.snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Provider;
          data.UID = a.payload.doc.id;

          return data;

        });
      });
    }


  }

  /*GET IN STOCK*/
  getListProvidersBasic(UID_RESTAURANT) {
    this.providerCol = this.afs.collection('providers', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('name', 'asc'));
    this.providers_stock = this.providerCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Provider;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getProviders(UID_RESTAURANT) {
    const providersRef = this.firestore.collection('providers');

    var providers = [];

    await providersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var provider = doc.data();
          provider.UID = doc.id;

          providers.push(provider);
        });
      });

    return providers
  }

  async getProvider(uid) {
    const provRef = this.firestore.collection('providers').doc(uid);

    var _prov;

    await provRef.get().then(doc => {

      if (doc.data()) {
        _prov = doc.data();
        _prov.UID = doc.id;
      }

    })

    return _prov;

  }


  delete(uid) {
    this.afs.doc('providers/' + uid).delete();
  }

  //get ingredients of provider
  async getIngredientsProvider(UID_RESTAURANT, provider_uid) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var ing = doc.data();
          ing.UID = doc.id;
          //
          for (let provider of ing.providers) {
            if (provider.uid == provider_uid) {
              ingredients.push(ing);
            }
          }
        });
      });

    return ingredients
  }

  //get ingredients of provider
  async getProductsProvider(UID_RESTAURANT, provider_uid) {
    const productsRef = this.firestore.collection('products');

    var products = [];

    await productsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var prod = doc.data();
          prod.UID = doc.id;
          //
          for (let provider of prod.providers) {
            if (provider.uid == provider_uid) {
              products.push(prod);
            }
          }
        });
      });

    return products
  }



  //get orders cart
  async getElementsCart(UID_RESTAURANT, UID_USER) {
    //recuperamos ingr, prods y prov
    var ingredients = await this.getIngredients(UID_RESTAURANT);
    var products = await this.getProducts(UID_RESTAURANT);
    var _providers = await this.getProviders(UID_RESTAURANT);
    //init
    var elements = [];
    var providers = [];
    var return_array = []
    var total_order = 0;
    var total_providers = 0;
    this.ings_prods_error = [];
    //recuperamos ordenes de compra
    const cartRef = this.firestore.collection('cart');
    await cartRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('UID_USER', '==', UID_USER)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var element = doc.data();
          element.UID = doc.id;
          //buscamos si existe el elemento
          var index = elements.findIndex(x => x.uid == element.uid);
          //no existe añadimos
          if (index < 0) {

            if (element.insert == 'manual') {
              elements.push(element);
            } else {
              element.quantity_dishmenu = element.quantity;
              element.quantity = 0;
              elements.push(element);
            }

          } else {
            //existe sumamos el stock al elemento
            if (element.insert == 'manual') {
              elements[index].quantity = elements[index].quantity + element.quantity;// cas manual sumar a cantidad
            } else {
              if (elements[index].quantity_dishmenu != undefined) {//cas dishmenu crear una nueva cantidad para calculos mas adelante
                elements[index].quantity_dishmenu = elements[index].quantity_dishmenu + element.quantity;
              } else {
                elements[index].quantity_dishmenu = element.quantity;
              }

            }

            //elements[index].quantity = elements[index].quantity + element.quantity;
          }
        });
      });

    //recoremos elementos
    for (let _element of elements) {
      //si es ingrediente
      if (_element.type == 'ingredient') {
        //buscamos el ingrediente en la lista de ingredientes
        var index_ingr = ingredients.findIndex(x => x.UID == _element.uid);
        //si existe
        if (index_ingr >= 0) {
          //
          var total_ingr = 0;
          var sub_total_ingr = 0;
          var i_ingr = ingredients[index_ingr].providers.findIndex(x => x.default == true);
          //mirar que el ingrediente tenga los proveedores (casos que crean mal un ingrediente)
          if (ingredients[index_ingr].providers[i_ingr]) {
            var i_prov = _providers.findIndex(x => x.UID == ingredients[index_ingr].providers[i_ingr].uid);

            if (_element.quantity_dishmenu != undefined) {//creat quantity_dishmenu
              if (ingredients[index_ingr].stock - _element.quantity_dishmenu < 0) {//cas falta quantitat stock insuficient
                _element.quantity += +Math.abs(ingredients[index_ingr].stock - _element.quantity_dishmenu);//sumamos a cantidad lo que neceistamos
                _element.stock_left = ingredients[index_ingr].stock;//stock que falta a 0 porque hemos gastado el que tenemos
              } else {//
                _element.stock_left = ingredients[index_ingr].stock;
              }
            } else {
              _element.stock_left = ingredients[index_ingr].stock;
              /*if (_element.quantity_dishmenu != undefined) {
                if (_element.stock_left != undefined) {
                  _element.stock_left += +Math.abs(ingredients[index].stock - _element.quantity_dishmenu);
                } else {
                  _element.stock_left = +Math.abs(ingredients[index].stock - _element.quantity_dishmenu);
                }
              }*/
            }

            _element.stock = ingredients[index_ingr].stock;
            //_element.quantity = _element.quantity - ingredients[index].stock;
            _element.name = ingredients[index_ingr].name || '';
            // ✅ Validación: Asegurar que price, price_tax y tax sean números válidos
            _element.price = parseFloat(ingredients[index_ingr].providers[i_ingr].price_static) || 0;
            _element.price_tax = parseFloat(ingredients[index_ingr].providers[i_ingr].pricetotal_static) || 0;
            _element.provider_uid = ingredients[index_ingr].providers[i_ingr].uid;
            _element.tax = parseFloat(ingredients[index_ingr].providers[i_ingr].tax_static) || 0;
            _element.measurement = ingredients[index_ingr].measurement || 'ud';
            _element.ean = ingredients[index_ingr].ean || '';
            // ✅ Validación: Asegurar que quantity sea número válido
            _element.quantity = parseFloat(_element.quantity) || 0;
            //calcular
            if (_element.quantity > 0) {
              _element.sub_total = this.globals.calculatePrice(_element.price, _element.quantity, _element.measurement);
              _element.total = this.globals.calculatePrice(_element.price_tax, _element.quantity, _element.measurement);
              total_ingr += _element.total;
              sub_total_ingr += _element.sub_total;
            } else {
              _element.sub_total = 0;
              _element.total = 0;
              total_ingr = 0;
              sub_total_ingr = 0;
            }
            //añadimos el proveedor a la lista de proveedores
            ingredients[index_ingr].providers[i_ingr].address = _providers[i_prov].address;
            ingredients[index_ingr].providers[i_ingr].contact_name = _providers[i_prov].contact_name;
            //email null
            if (_providers[i_prov].email == null) {
              ingredients[index_ingr].providers[i_ingr].email = "";
            } else {
              ingredients[index_ingr].providers[i_ingr].email = _providers[i_prov].email;
            }
            //phone null
            if (_providers[i_prov].phone == null) {
              ingredients[index_ingr].providers[i_ingr].phone = "";
            } else {
              ingredients[index_ingr].providers[i_ingr].phone = _providers[i_prov].phone;
            }
            //
            ingredients[index_ingr].providers[i_ingr].notes = "";
            ingredients[index_ingr].providers[i_ingr].state = "show";

            var i_prov_providers = providers.findIndex(x => x.uid == ingredients[index_ingr].providers[i_ingr].uid);
            if (i_prov_providers >= 0) {
              providers[i_prov_providers].total = providers[i_prov_providers].total + total_ingr;
              providers[i_prov_providers].sub_total = providers[i_prov_providers].sub_total + sub_total_ingr;
              total_order += total_ingr;
            } else {
              ingredients[index_ingr].providers[i_ingr].total = total_ingr;
              ingredients[index_ingr].providers[i_ingr].sub_total = sub_total_ingr;
              providers.push(ingredients[index_ingr].providers[i_ingr]);
              total_providers++;
              total_order += total_ingr;
            }
          } else {
            ingredients[index_ingr].type = 'ingredient';
            this.ings_prods_error.push(ingredients[index_ingr]);
          }
        }
        //si es producto
      } else {
        //buscamos el producto en la lista de productos
        var index_prod = products.findIndex(x => x.UID == _element.uid);
        //si existe
        if (index_prod >= 0) {
          //
          var total_prod = 0;
          var sub_total_prod = 0;
          var i_prod = products[index_prod].providers.findIndex(x => x.default == true);
          //mirar si el producto tiene proveedores (caso creacion mal)
          if (products[index_prod].providers[i_prod]) {
            var i_prov_prod = _providers.findIndex(x => x.UID == products[index_prod].providers[i_prod].uid);
            //añadimos datos del proveedor al elemento
            _element.stock = products[index_prod].stock;
            //_element.quantity = _element.quantity - products[index].stock;
            _element.name = products[index_prod].name || '';
            // ✅ Validación: Asegurar que price, price_tax y tax sean números válidos
            _element.price = parseFloat(products[index_prod].providers[i_prod].price_static) || 0;
            _element.price_tax = parseFloat(products[index_prod].providers[i_prod].pricetotal_static) || 0;
            _element.provider_uid = products[index_prod].providers[i_prod].uid;
            _element.tax = parseFloat(products[index_prod].providers[i_prod].tax_static) || 0;
            _element.measurement = products[index_prod].measurement || 'ud';
            _element.ean = products[index_prod].ean || '';
            // ✅ Validación: Asegurar que quantity sea número válido
            _element.quantity = parseFloat(_element.quantity) || 0;
            //stock left
            if (products[index_prod].stock) {
              _element.stock_left = products[index_prod].stock;
            }
            //calcular total comanda
            if (_element.quantity > 0) {
              _element.sub_total = this.globals.calculatePrice(_element.price, _element.quantity, _element.measurement);
              _element.total = this.globals.calculatePrice(_element.price_tax, _element.quantity, _element.measurement);
              total_prod += _element.total;
              sub_total_prod += _element.sub_total;
            } else {
              _element.sub_total = 0;
              _element.total = 0;
              total_prod = 0;
              sub_total_prod = 0;
            }
            //añadimos el proveedor a la lista de proveedores
            if (_providers[i_prov_prod]) {
              //null address
              if (_providers[i_prov_prod].address == null) {
                products[index_prod].providers[i_prod].address = "";
              } else {
                products[index_prod].providers[i_prod].address = _providers[i_prov_prod].address;
              }
              //null contact_name
              if (_providers[i_prov_prod].contact_name == null) {
                products[index_prod].providers[i_prod].contact_name = "";
              } else {
                products[index_prod].providers[i_prod].contact_name = _providers[i_prov_prod].contact_name;
              }
              //null email
              if (_providers[i_prov_prod].email == null) {
                products[index_prod].providers[i_prod].email = "";
              } else {
                products[index_prod].providers[i_prod].email = _providers[i_prov_prod].email;
              }
              //null email
              if (_providers[i_prov_prod].phone == null) {
                products[index_prod].providers[i_prod].phone = "";
              } else {
                products[index_prod].providers[i_prod].phone = _providers[i_prov_prod].phone;
              }
            } else {
              products[index_prod].providers[i_prod].address = "";
              products[index_prod].providers[i_prod].contact_name = "";
              products[index_prod].providers[i_prod].email = "";
              products[index_prod].providers[i_prod].phone = "";
            }


            products[index_prod].providers[i_prod].notes = "";
            products[index_prod].providers[i_prod].state = "show";

            //si existeix en la llista providers
            var i_prov_providers_prod = providers.findIndex(x => x.uid == products[index_prod].providers[i_prod].uid);
            if (i_prov_providers_prod >= 0) {
              providers[i_prov_providers_prod].total = providers[i_prov_providers_prod].total + total_prod;
              providers[i_prov_providers_prod].sub_total = providers[i_prov_providers_prod].sub_total + sub_total_prod;
              total_order += total_prod;
            } else {
              products[index_prod].providers[i_prod].total = total_prod;
              products[index_prod].providers[i_prod].sub_total = sub_total_prod;
              total_order += total_prod;
              providers.push(products[index_prod].providers[i_prod]);
              total_providers++;
            }
          } else {
            products[index_prod].type = 'product';
            this.ings_prods_error.push(products[index_prod]);
          }
        }

      }
    }

    // juntamos y devolvemos
    return_array.push(elements);
    return_array.push(providers);
    return_array.push(total_order);
    return_array.push(total_providers);
    return return_array;

  }


  //get ingredients of provider
  async getIngredients(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var ing = doc.data();
          ing.UID = doc.id;
          //
          ingredients.push(ing);

        });
      });

    return ingredients
  }

  //get ingredients of provider
  async getProducts(UID_RESTAURANT) {
    const productsRef = this.firestore.collection('products');

    var products = [];

    await productsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var prod = doc.data();
          prod.UID = doc.id;
          //
          products.push(prod);

        });
      });

    return products
  }

  //delete elements of cart
  async deleteCartElements(UID_RESTAURANT, element_uid, UID_USER) {
    const cartRef = this.firestore.collection('cart');
    await cartRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('uid', '==', element_uid)
      .where('UID_USER', '==', UID_USER)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //eliminamos
          this.firestore.collection('cart').doc(doc.id).delete();
        });
      });

  }

  //get provider orders
  async getProvidersOrders(UID_RESTAURANT, UID_USER) {
    const provider_orderRef = this.firestore.collection('provider_order');

    var provider_orders = [];

    // Si es admin, obtener todos los pedidos del restaurante
    if (this.globals.user_access.includes('admin')) {
      await provider_orderRef
        .where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            //
            var prod = doc.data();
            prod.UID = doc.id;
            //
            provider_orders.push(prod);

          });
        });
    } else {
      // Si no es admin, solo obtener pedidos del usuario actual
      await provider_orderRef
        .where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .where('UID_USER', '==', UID_USER)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            //
            var prod = doc.data();
            prod.UID = doc.id;
            //
            provider_orders.push(prod);

          });
        });
    }

    return provider_orders
  }

  //get provider orders
  async getProviderOrder(uid) {
    const provRef = this.firestore.collection('provider_order').doc(uid);

    var _prov;

    await provRef.get().then(doc => {
      _prov = doc.data();
      _prov.UID = doc.id;
    })

    return _prov;
  }


async emptyCart(UID_RESTAURANT, UID_USER) {
  const cartRef = this.firestore.collection('cart');
  await cartRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
    .where('UID_USER', '==', UID_USER)
    .get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        //eliminamos
        this.firestore.collection('cart').doc(doc.id).delete();
      });
    });
}

  async getTotalCartElements(UID_RESTAURANT, UID_USER) {
    //
    var elements = [];
    //
    const cartRef = this.firestore.collection('cart');
    await cartRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('UID_USER', '==', UID_USER)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var element = doc.data();
          element.UID = doc.id;
          //buscamos si existe el elemento
          var index = elements.findIndex(x => x.uid == element.uid);
          //no existe añadimos
          if (index < 0) {
            elements.push(element);
            //existe sumamos el stock al elemento
          }
        });
      });
    this.globals.cart_elements = elements.length;
  }

  async getProviderOrders(UID_RESTAURANT, UID_USER) {

    // Si es admin, obtener todos los pedidos del restaurante
    if (this.globals.user_access.includes('admin')) {
      this.providerOrderCol = this.afs.collection('provider_order', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .orderBy('created_at', 'desc'));
    } else {
      // Si no es admin, solo obtener pedidos del usuario actual
      this.providerOrderCol = this.afs.collection('provider_order', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .where('UID_USER', '==', UID_USER)
        .orderBy('created_at', 'desc'));
    }
    this.providerOrders = this.providerOrderCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as ProviderOrder;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }


  async getNoProvider(UID_RESTAURANT) {
    const providerRef = this.firestore.collection('providers');

    var no_provider;

    await providerRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('no_provider', '==', true)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          //
          var provider = doc.data();
          provider.UID = doc.id;
          no_provider = provider;

        });
      });

    return no_provider
  }


  async setIngredientDefault(ingredient_uid, provider_uid, provider_name, price, tax, total) {

    // get ingredient for use providers
    var ingredient = await this.ingredientsServices.getIngredient(ingredient_uid);

    var providers = ingredient.providers;
    //desmarcar default
    const i = providers.findIndex(provider => provider.default === true);
    if (i >= 0) {
      providers[i].default = false;
    }
    //existe proveedor??
    const j = providers.findIndex(provider => provider.uid === provider_uid);

    if (j >= 0) { //si (marcar default)
      providers[j].default = true;
      providers[j].price_static = price;
      providers[j].pricetotal_static = total;
      providers[j].tax_static = tax;

    } else {//no (añadir a array y marcar default)
      providers.push({
        uid: provider_uid,
        default: true,
        price_static: price,
        name_static: provider_name,
        pricetotal_static: total,
        tax_static: tax,
        updated_at: new Date(),
      });
    }
    //update firebase
    this.ingredientsServices.afs.collection('ingredients').doc(ingredient_uid).update({
      'provider_static': provider_name,
      'price_static': price,
      'providers': providers,
    }).then(() => { });

  }

  async setProductDefault(product_uid, provider_uid, provider_name, price, tax, total) {

    // get product for use providers
    var product = await this.productsServices.getProduct(product_uid);

    var providers = product.providers;
    //desmarcar default
    const i = providers.findIndex(provider => provider.default === true);
    if (i >= 0) {
      providers[i].default = false;
    }
    //existe proveedor??
    const j = providers.findIndex(provider => provider.uid === provider_uid);
    if (j >= 0) { //si (marcar default)
      providers[j].default = true;
      providers[j].price_static = price;
      providers[j].pricetotal_static = total;
      providers[j].tax_static = tax;
    } else {//no (añadir a array y marcar default)
      providers.push({
        uid: provider_uid,
        default: true,
        price_static: price,
        name_static: provider_name,
        pricetotal_static: total,
        tax_static: tax,
        updated_at: new Date(),
      });
    }
    //update firebase
    this.productsServices.afs.collection('products').doc(product_uid).update({
      'provider_static': provider_name,
      'price_static': price,
      'providers': providers,
    }).then(() => { });
  }

  //FILTER
  public filteredProviders: any;
  public filteredProvidersActive: boolean = false;
  searchProviderNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredProvidersActive = false;
    } else {
      if (value.target.value.length >= 3) {
        //
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/provider', params, {})
          .subscribe(async res => {
            this.filteredProviders = res;
            this.getFilterProvider();
          });

      } else {
        this.filteredProvidersActive = false;
      }
    }
  }

  getFilterProvider() {
    //Ordenamos el array
    this.filteredProviders.sort((a, b) => a.name.localeCompare(b.name));

    //Recorremos el array filtrada
    this.filteredProviders.forEach(provider => {
      //Buscamos el plato en el array no filtrada de platos para ver los que no estan activos por version
      var index = this.list_providers_array_tmp.findIndex(x => x.UID == provider.UID);
      if (index >= 0) {
        provider._active = this.list_providers_array_tmp[index]._active;
      } else {
        provider._active = false;
      }
    });
    this.filteredProvidersActive = true;
  }

  _providers_array_tmp: any = [];
  list_providers_array: any = [];
  providers_array_filtered: any = [];
  providers_searchbar_text: any = '';

  async getPagesProvider(loader) {
    this.get_providers_done = loader;
    //si no tiene límite le buscamos todos los proveedores
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    await this.http.post(this.globals.analytics_path + 'paginate/provider', params, {})
      .subscribe(async res => {
        this.first_providers_name = res['first_providers_name'];
        this._providers_array_tmp = res['list_providers'];
        if (this._providers_array_tmp.length != 0) {
          this.getListProvidersMinMax();
        } else {
          this.get_providers_done = true;
        }
      });
  }
  /*GET PROVIDERS*/
  getListProvidersMinMax() {
    this.get_providers_done = true;
    //Ordenamos el array
    this._providers_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
    //For para poner en activo los platos que puede ver el free.
    this._providers_array_tmp.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('stock', 'providers') && this.globals.checkLimitsByLicense('stock', 'providers') != -1) {
        value._active = false;
      }
    });
    this.list_providers_array = this._providers_array_tmp;
    this.providers_array_filtered = this._providers_array_tmp;
    this.providersSearch(this.providers_searchbar_text);
  }

  providersSearch(value) {
    if (value) {
      this.providers_array_filtered = this.list_providers_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.providers_array_filtered = this.list_providers_array;
    }
  }

  get_ingredients_done: boolean = false;
  list_ingredients: any;
  first_ingredient_name: any;
  providers_ingredients_array: any;
  async getPagesIngredientsProvider(elements_per_page, uid_provider) {
    this.get_ingredients_done = false;
    //this.filteredProvidersElementsActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('uid_provider', uid_provider)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/provider_ingredients', params, {})
      .subscribe(async res => {
        this.pagesIngredients = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_ingredients = res['list_ingredients'];
        if (this.pagesIngredients != 0) { //Si hay paginas
          this.getListIngredientsProviders();
        } else { //Si no hay paginas
          this.get_ingredients_done = true;
        }
      });
  }

  public filteredProvidersElements: any;
  public filteredProvidersElementsActive: boolean = false;
  searchElementsProvidersNode(value, provider_uid, type) {
    if (type === 'ingredient') {
      if (value) {
        this.providers_ingredients_array = this.providers_ingredients_array_tmp.filter(objeto => {
          return this.globals.objectToArray(objeto).some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              // Comparar como string
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              // Buscar en cada elemento del array
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
        });
      } else {
        this.providers_ingredients_array = this.providers_ingredients_array_tmp;
      }
    } else if (type === 'product') {
      if (value) {
        this.providers_products_array = this.providers_products_array_tmp.filter(objeto => {
          return this.globals.objectToArray(objeto).some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              // Comparar como string
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              // Buscar en cada elemento del array
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
        });
      } else {
        this.providers_products_array = this.providers_products_array_tmp;
      }
    } else {
      if (value) {
        this.delivery_notes_array = this.delivery_notes_array_tmp.filter(objeto => {
          return this.globals.objectToArray(objeto).some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              // Comparar como string
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              // Buscar en cada elemento del array
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
        });
      } else {
        this.delivery_notes_array = this.delivery_notes_array_tmp;
      }
    }
  }

  getListIngredientsProviders() {
    this.get_ingredients_done = true;

    //Ordenamos el array
    this.list_ingredients.sort((a, b) => a.name.localeCompare(b.name));


    for (let ingredient of this.list_ingredients) {

      ingredient._active = true;
      if (!this.globals.checkLimitsByLicense('stock', 'ings')) {
        //si en la licencia no puede tener ingredientes se los desactiavamos
        ingredient._active = false;
      }

    }

    //Search for first element to start
    this.first_ingredient_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.providers_ingredients_array = this.list_ingredients.slice(this.first_ingredient_name, this.first_ingredient_name + this.limit_pages);

    // guardamos un array temporal para providers-create data
    this.providers_ingredients_array_tmp = this.providers_ingredients_array
  }

  pagesProducts: any;
  get_products_done: boolean = false;
  list_products: any;
  first_product_name: any;
  providers_products_array: any;
  async getPagesProductsProvider(elements_per_page, uid_provider) {



    this.get_products_done = false;
    //this.filteredProvidersElementsActive = false;
    this.limit_pages = elements_per_page;




    let limit_products = this.globals.checkLimitsByLicense('stock', 'ings_prods');
    //Miramos si la licencia tiene límite de stock o de platos
    if (limit_products >= 0) {

      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('uid_provider', uid_provider)
        .set('elements_per_page', elements_per_page)
        .set('limit', limit_products);
      await this.http.post(this.globals.analytics_path + 'paginate/limited_provider_products', params, {})
        .subscribe(async res => {
          this.pagesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
          this.list_products = res['list_products'];
          if (this.pagesProducts != 0) { //Si hay paginas
            this.getListProductsProviders();
          } else { //Si no hay paginas
            this.get_products_done = true;
          }
        });
    } else {

      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('uid_provider', uid_provider)
        .set('elements_per_page', elements_per_page);
      await this.http.post(this.globals.analytics_path + 'paginate/provider_products', params, {})
        .subscribe(async res => {

          this.pagesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
          this.list_products = res['list_products'];
          if (this.pagesProducts != 0) { //Si hay paginas
            this.getListProductsProviders();
          } else { //Si no hay paginas
            this.get_products_done = true;
          }
        });
    }
  }

  getListProductsProviders() {
    this.get_products_done = true;

    //Ordenamos el array
    this.list_products.sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));

    for (let product of this.list_products) {
      var _prod = this.stockServices.list_ingprod_array.find(e => e.UID === product.UID);
      if (_prod) {
        product._active = _prod._active;
      }
    }

    //Search for first element to start
    this.first_product_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.providers_products_array = this.list_products.slice(this.first_product_name, this.first_product_name + this.limit_pages);

    // guardamos un array temporal para providers-create data
    this.providers_products_array_tmp = this.providers_products_array

  }

  get_orders_suppliers_done: boolean = false;
  orders_suppliers_array_tmp: any = [];
  list_orders_suppliers_array: any = [];
  orders_suppliers_array_filtered: any = [];
  orders_suppliers_searchbar_text: any = '';
  async getPagesOrdersSuppliers(loader, date_first, date_last, UID_USER) {
    this.get_orders_suppliers_done = loader;

    // Si no es admin, usar Firestore directamente para garantizar filtro por usuario
    if (!this.globals.user_access.includes('admin')) {
      
      // Usar Firestore directamente para usuarios no admin
      const provider_orderRef = this.firestore.collection('provider_order');
      const startDate = new Date(date_first);
      const endDate = new Date(date_last);
      
      
      await provider_orderRef
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .where('UID_USER', '==', UID_USER)
        .where('created_at', '>=', startDate)
        .where('created_at', '<=', endDate)
        .orderBy('created_at', 'desc')
        .get()
        .then(snapshot => {
          this.orders_suppliers_array_tmp = [];
          snapshot.forEach(doc => {
            var prod = doc.data();
            prod.UID = doc.id;
            this.orders_suppliers_array_tmp.push(prod);
          });
          this.total_orders_suppliers = this.orders_suppliers_array_tmp.length;
        })
        .catch(error => {
          console.error('Error en consulta Firestore:', error);
          this.orders_suppliers_array_tmp = [];
          this.total_orders_suppliers = 0;
          this.get_orders_suppliers_done = true;
        });
        
      if (this.orders_suppliers_array_tmp.length != 0) {
        this.getListOrdersSuppliersNode();
      } else {
        this.get_orders_suppliers_done = true;
      }
      
    } else {
      // Admin: Usar endpoint HTTP para obtener todos los pedidos
      
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('datetime_init', date_first)
        .set('datetime_final', date_last);


      await this.http.post(this.globals.analytics_path + 'paginate/paginate_orders_suppliers', params, {})
        .subscribe(async res => {

          this.orders_suppliers_array_tmp = res['list_provider_orders'];
          this.total_orders_suppliers = res['total'];
          
          if (this.orders_suppliers_array_tmp.length != 0) {
            this.getListOrdersSuppliersNode();
          } else { //Si no hay paginas
            this.get_orders_suppliers_done = true;
          }
        });
    }

  }

  getListOrdersSuppliersNode() {
    this.get_orders_suppliers_done = true;
    this.list_orders_suppliers_array = this.orders_suppliers_array_tmp;
    this.orders_suppliers_array_filtered = this.orders_suppliers_array_tmp;
    this.ordersSuppliersSearch(this.orders_suppliers_searchbar_text);
  }

  ordersSuppliersSearch(value) {
    if (value) {
      this.orders_suppliers_array_filtered = this.list_orders_suppliers_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.orders_suppliers_array_filtered = this.list_orders_suppliers_array;
    }
  }


  delivery_notes_array = []


  // arrays temporales
  providers_ingredients_array_tmp = []
  providers_products_array_tmp = []
  delivery_notes_array_tmp = []

  async get_provider_delivery_notes(UID_RESTAURANT, UID_PROVIDER) {
    try {
      let total = 0
      let doc = firebase.firestore()
      await doc.collection('delibery_note')
        .where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .where('uid_provider', '==', UID_PROVIDER)
        .orderBy('date', 'asc')
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let prod = doc.data();
            prod.UID = doc.id;
            prod.type = 'delibery_note';
            if (prod.list) {
              for (let price of prod.list) {
                total += price.total
              }
            }
            total = Math.round(total * 100) / 100;
            prod.total = total
            this.delivery_notes_array.push(prod); // Agregar la nota de entrega al arreglo
          });

          // guardamos un array temporal para providers-create data
          this.delivery_notes_array_tmp = this.delivery_notes_array;
          this.delivery_notes_array = [...this.delivery_notes_array];

        })
        .catch((err) => { });
    }
    catch (err) {
      return [];
    }
  }


}


// WEBPACK FOOTER //
// ./src/pages/providers/services.ts